import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Pill from "@khanacademy/wonder-blocks-pill";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

type PillProps = React.ComponentProps<typeof Pill>;
type PillKind = PillProps["kind"];
type Props = {
    kind?: PillKind;
    testId?: string;
};

const NewBadge = ({
    kind = "accent",
    testId,
}: Props): React.ReactElement<React.ComponentProps<"span">> => (
    <Pill kind={kind} size="small" style={styles.pill} testId={testId}>
        {t`NEW`}
    </Pill>
);

const styles = StyleSheet.create({
    pill: {
        // causes the badge's width to be cut short. Set it to
        // "auto" here to stop that from happening.
        minWidth: "auto",
        // Reduce left and right padding to give the text more space.
        paddingInlineStart: spacing.xxxSmall_4,
        paddingInlineEnd: spacing.xxxSmall_4,
    },
});

export default NewBadge;
